import React from "react";
import Ajax, { domain } from "../../ajax/Ajax";

class Signup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      password: "",
      accountCreationSuccessful: false,
      accountCreationError: false,
      userAlreadyExist: false,
      submitting: false,
    };

    this.createAccount = this.createAccount.bind(this);
  }

  async createAccount(event) {
    event.preventDefault();
    let setUser = this.props.setUser;

    let data = {
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
    };

    this.setState({
      submitting: true,
      accountCreationSuccessful: false,
      accountCreationError: false,
      userAlreadyExist: false,
    });

    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/buyer/",
      data
    );
    if (response) {
      console.log(response);
      if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.token);

        this.setState({
          user: response.data.user,
          accountCreationSuccessful: true,
          submitting: false,
          name: "",
          email: "",
          password: "",
        });

        setTimeout(function () {
          setUser(response.user);
        }, 1000);
      } else if (response.status === 406) {
        this.setState({
          submitting: false,
          userAlreadyExist: true,
        });
      }
    } else {
      this.setState({
        submitting: false,
        accountCreationError: true,
      });
    }
  }

  render() {
    let submitting = "";
    if (this.state.submitting) {
      submitting = "is-loading";
    }
    return (
      <div>
        <div>
          {this.state.accountCreationError ? (
            <div className="message is-danger">
              <div className="message-body">
                <div className="has-text-centered is-size-4">
                  <span className="zmdi zmdi-close-circle has-text-danger"></span>
                </div>
                <div className="has-text-centered">
                  An Error occurred. Please try again later
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {this.state.accountCreationSuccessful ? (
            <div className="message is-success">
              <div className="message-body">
                <div className="has-text-centered is-size-4">
                  <span className="zmdi zmdi-check-circle has-text-success"></span>
                </div>
                <div className="has-text-centered">
                  Account successfully created!
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {this.state.userAlreadyExist ? (
            <div className="message is-warning">
              <div className="message-body">
                <div className="has-text-centered is-size-4">
                  <span className="zmdi zmdi-close-circle has-text-warning"></span>
                </div>
                <div className="has-text-centered">
                  Account already exist for this email.{" "}
                  <a
                    onClick={() => {
                      this.props.toggleSigupLogin(true);
                    }}
                    href="#!"
                  >
                    Login here
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {!this.state.accountCreationSuccessful ? (
          <form action="#" onSubmit={this.createAccount}>
            <div className="has-text-centered field">
              <strong> Please identify yourself</strong>
            </div>
            <div className="field">
              <input
                value={this.state.name}
                onChange={(event) => {
                  this.setState({ name: event.target.value });
                }}
                required
                name="fullname"
                placeholder="full name"
                type="text"
                className="input"
              />
            </div>
            <div className="field">
              <input
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                required
                name="email"
                placeholder="email"
                type="email"
                className="input"
              />
            </div>

            <div className="field">
              <input
                value={this.state.password}
                onChange={(event) => {
                  this.setState({ password: event.target.value });
                }}
                required
                name="password"
                placeholder="password"
                type="password"
                className="input"
              />
            </div>

            <div className="field">
              <button className={submitting + " button is-info is-fullwidth"}>
                Create Account
              </button>
            </div>
            <div className="field">
              I already have an account.{" "}
              <span>
                <a
                  href="#!"
                  onClick={() => {
                    this.props.toggleSigupLogin(true);
                  }}
                >
                  Login
                </a>
              </span>
            </div>
          </form>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Signup;
